module.exports = __webpack_public_path__ + "img/CB_Hellborn Marauder.b957e5ce.gif";